import { FieldType } from '90.quickConnect.Models/enums';
import { AllFieldValueTypes, FieldData } from '90.quickConnect.Models/models';
import { isFieldDataArray } from '90.quickConnect.Models/guards';

// Champs dont la valeur ne provient pas de la saisie de l'utilisateur
const notEnteredFieldTypes: FieldType[] = [
  FieldType.Label,
  FieldType.Separator,
  FieldType.FixedImage,
  FieldType.FixedAttachment,
  FieldType.Alert,
  FieldType.Compute,
  FieldType.ReadOnlyValue,
];

const isEmptyValue = (value: AllFieldValueTypes | FieldData[]): boolean =>
  value === undefined ||
  value === null ||
  value === '' ||
  value === false ||
  (Array.isArray(value) && value.length === 0);

const countFilledFields = (fields: FieldData[]): number =>
  fields.reduce((count: number, field: FieldData) => {
    if (isFieldDataArray(field, field.value) && field.fieldType !== FieldType.Action)
      return count + countFilledFields(field.value);

    return notEnteredFieldTypes.includes(field.fieldType) || isEmptyValue(field.value) ? count : count + 1;
  }, 0);

/**
 * Nombre de champs renseignés par l'utilisateur dans une sauvegarde automatique (conteneurs exclus)
 * @param editedData Champs de la déclaration, sérialisés en JSON
 */
export const countSavedFields = (editedData: string | undefined): number => {
  if (!editedData) return 0;

  try {
    return countFilledFields(JSON.parse(editedData));
  } catch {
    return 0;
  }
};
